<template>
  <div>
    <b-table :sort-by.sync="sortBy"
      :tbody-tr-class="rowClass"
      stacked="md" responsive striped hover
      :items="this.ListaCargoPersonal.filter(c => c.EstadoCargoPersonal === 'Activo' || c.EstadoCargoPersonal === 'EnLicencia')"
      :fields="fields">
      <template #head(actions)="head">
        {{ head.label }}
        <!-- <input type="checkbox" @click.stop="checkAllCargos" v-model="allCargosSelected"> -->
      </template>
      <template #cell(actions)="item">
        <input v-if="seleccionable && (item.item.EstadoCargoPersonal === 'Activo' || item.item.EstadoCargoPersonal === 'EnLicencia') && (!seleccionados.includes(item.item.Id))"
          type="checkbox"
          name="checked"
          :key="item.index"
          :value="item.item.Id"
          v-model="ListaCargoPersonalSeleccionado"
          @click.stop >
      </template>
      <template #cell(show_details)="row">
        <b-button variant="primary" size="sm" @click.stop="row.toggleDetails" title="Ver Más">
        <b-icon icon="eye"></b-icon>
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <ul id="example-1">
              <li v-for="item in row.item.CargoEstablecimiento.CargoDetalleCurricular" v-bind:key="item.Id">
                <b>{{ "Año Académico: " }}</b> {{ item.AñoAcademico }} | <b>{{ "Espacio Curricular: "}}</b>{{ item.EspacioCurricular }} <br/><hr/>
                <ul>
                  <b-badge variant="success">{{ "Horarios" }}</b-badge>
                  <li v-for="horario in item.HorariosCargoDetalleCurricular" v-bind:key="horario.Id">
                    {{ horario.DisplayHorario }}
                  </li>
                </ul>
                <br/>
                <hr/>
              </li>
            </ul>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>Cant. dias de licencia :</b></b-col>
            <b-col><b-badge variant="success">{{ row.item.CantidadDiasLicencia }}</b-badge></b-col>
          </b-row>
        <b-button variant="success" size="sm" @click="row.toggleDetails">Ocultar</b-button>
        </b-card>
      </template>
      <template slot="table-caption">
        <small><b>Total Items :</b></small> <b-badge variant="success">{{ this.ListaCargoPersonal.filter(c => c.EstadoCargoPersonal === 'Activo' || c.EstadoCargoPersonal === 'EnLicencia').length }}</b-badge><small> | <b>Ordenado por : </b>{{ sortBy }}</small>
      </template>
    </b-table>
  </div>
</template>
<script>
import { createHelpers } from 'vuex-map-fields';


const { mapFields: mapFormSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "TablaCargoPersonal",
  computed: {
    ...mapFormSolicitudFields(['ListaCargoPersonalSeleccionado']),
    ...mapFormBuscarPersonalFields(['ListaCargoPersonal'])
  },
  props: {
    seleccionable: Boolean,
    seleccionados: {
        type: Array,
        default:()=>[]
      }
  },
  watch: {
  },
  data() {
    return {
      sortBy: 'Id',
      fields: [
        {
          key: 'actions',
          label: '',
        },
        {
          key: 'Id',
          label: 'Id',
          sortable: true,
          class: 'text-center',
          thStyle: {
              maxWidth: '80px',
              minWidth: '80px'
          }
        },
        {
          key: 'CargoEstablecimiento.Cargo.Cupof',
          label: 'CUPOF',
        },
        {
          key: 'CargoEstablecimiento.Cargo.DisplayInfoCargo',
          label: 'Descripción',
        },
        {
          key: 'SituacionRevista',
          label: 'Revista',
        },
        {
          key: 'CargoEstablecimiento.Establecimiento',
          label: 'Establecimiento',
        },
        {
          key: 'CargoEstablecimiento.NivelEnseñanza',
          label: 'Nivel',
        },
        {
          key: 'CargoEstablecimiento.Cargo.TipoCargo',
          label: 'Tipo',
        },
        {
          key: 'EstadoCargoPersonal',
          label: 'Estado',
        },
        {
          key: 'show_details',
          label: 'Acciones',
        },
      ],
    }
  },
  methods: {
    rowClass(item, type) {
      console.log(item, type);
      if(this.seleccionados.includes(item.Id)){
        return 'table-success'
      }
      return '';
    }
  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TablaCargoPersonal.vue